// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"153":"bfa1576e","505":"d7a46694","627":"b1aed844","664":"bfa1576e","686":"3a40994e"}[chunkId] + ".chunk.css";
};